import { GetOAuthInfo, initAxios } from '@seiue/axios'
import { ConfigProvider, message } from 'antd'
import zhCn from 'antd/es/locale/zh_CN'
import { Provider as StoreProvider } from 'jotai'
import { Empty } from 'packages/components/Empty'
import React, { FC, useEffect } from 'react'
import ReactDOM from 'react-dom'
import { QueryClient, QueryClientProvider } from 'react-query'

import { App } from './App'
import { CONSTANTS, useActivityParam, useErrorHandler, utils } from './hooks'
import { getAdminOAuthInfoFn, getUserOAuthInfoFn } from './sessions'
import { isAdminStorage, store } from './store'
import '@seiue/ui/build/module/global-styles.less'
import './index.css'
import 'packages/theme/global.less'

// 应用初始化
const initializeApp = (): void => {
  const isActivity = utils.isActivity()

  initAxios({
    getOAuthInfo: !isActivity
      ? (getAdminOAuthInfoFn() as GetOAuthInfo)
      : (getUserOAuthInfoFn() as GetOAuthInfo),
  })

  store.set(isAdminStorage, !isActivity)
}

// 主渲染组件
const AppRenderer: FC = () => {
  const param = useActivityParam()
  const { handleUnhandledRejection } = useErrorHandler(param)

  useEffect(() => {
    // 添加全局错误监听
    window.addEventListener('unhandledrejection', handleUnhandledRejection)

    // 清理函数
    return () => {
      window.removeEventListener('unhandledrejection', handleUnhandledRejection)
    }
  }, [handleUnhandledRejection])

  useEffect(() => {
    // 配置全局消息提示
    message.config({
      top: CONSTANTS.MESSAGE_CONFIG.TOP_OFFSET,
    })
  }, [])

  return (
    <React.StrictMode>
      <ConfigProvider
        locale={zhCn}
        renderEmpty={() => Empty}
      >
        <StoreProvider store={store}>
          <QueryClientProvider client={queryClient}>
            <App />
          </QueryClientProvider>
        </StoreProvider>
      </ConfigProvider>
    </React.StrictMode>
  )
}

// 初始化应用
initializeApp()

// 创建查询客户端
const queryClient = new QueryClient()

// 渲染应用
ReactDOM.render(<AppRenderer />, document.getElementById('root'))
